export class PoOrder {
  collection_id: string;
  collection_name: string;
  color_id: string;
  color_name: string;
  design_name: string;
  mystic_color_name: string;
  mystic_design_name: string;
  mystic_collection_name?: string;
  quantity: number;
  unit_price: number;
  unit_type?: string;
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/pos/po-orders.ts